/**
 * Classement Superviseurs : performance sécurité individuelle (ponctualité
 * des actions/CCV + engagement dans le signalement des Findings).
 */
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CHARTS } from "@/constants/testIds";

export default function SupervisorRankingTable({ data = [] }) {
  return (
    <Card data-testid={CHARTS.ranking} className="border-slate-200 shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold uppercase tracking-wider text-slate-500">Classement BoG</CardTitle>
      </CardHeader>
      <CardContent className="max-h-[280px] space-y-1.5 overflow-y-auto pt-0">
        {data.length === 0 && <p className="py-6 text-center text-sm text-slate-400">Aucune donnée pour ce filtre.</p>}
        {data.map((p) => (
          <div
            key={p.email}
            data-testid={`ranking-row-${p.rank}`}
            className="flex items-center justify-between rounded-lg px-2 py-2 transition-colors duration-200 hover:bg-slate-50"
          >
            <div className="flex items-center gap-2.5">
              <span
                className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold ${
                  p.rank <= 3 ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-500"
                }`}
              >
                {p.rank}
              </span>
              <div>
                <p className="text-sm font-medium text-slate-700">{p.name}</p>
                <p className="text-xs text-slate-400">{p.site}</p>
              </div>
            </div>
            <Badge className="border-none bg-[#0B5394]/10 font-bold text-[#0B5394]">{p.score}</Badge>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
